import React, { useEffect, useState } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap';
import logoCenec from '../assets/cenec_2.svg';
import logoChorotega from '../assets/chorotega_2.svg';
import { ADVICE, TYPE_OF_ORGANIZATION, YESNO } from "../utils/constants";
import { useFormContext } from 'react-hook-form';
import Swal from 'sweetalert2';

export const SlideThree = ({ setFormData, formData }) => {
    const { register, setValue, formState: { errors } } = useFormContext();
    // const [acceptTerms, setAcceptTerms] = useState(null);

    useEffect(() => {
        // Seleccionar "No" predeterminadamente en "accept_terms"
        if (!formData.accept_terms) {
            setValue("accept_terms", "N");
            setFormData((prevData) => ({
                ...prevData,
                accept_terms: "N",
            }));
        }
    }, [setValue, setFormData, formData.accept_terms]);

    const handleAcceptTerms = (event) => {
        const acceptTermsValue = event.target.value;
        setFormData((prevData) => ({
            ...prevData,
            accept_terms: acceptTermsValue,  // Guarda el valor de aceptación en el estado global
        }));

        if (acceptTermsValue === "N") {
            Swal.fire({
                title: 'Contrato no aceptado',
                text: 'Tiene que aceptar los términos para continuar',
                icon: 'warning',
                confirmButtonText: 'Aceptar',
            });
        }
    };

    return (

        <Container className='' style={{ maxWidth: '1200px' }}>
            <div className='d-flex justify-content-center mb-3 ms-2 me-2'>
                <Card className='card-custom-style'>
                    <Card.Header className='white-bg-color'>
                        <Row className='justify-content-center'>
                            <Col md={10}>
                                <Row className='justify-content-center cenec-bg-color-v2 mx-1 p-3 rounded-1 mb-3 mt-3'>
                                    <Col xl={5} md={5} sm={5} xs={12} className='order-last order-sm-first order-md-first' >
                                        <div className='d-flex justify-content-center align-items-center'>
                                            <img src={logoCenec} alt="Logo CENEC" className='img-cenec' />
                                        </div>
                                    </Col>
                                    <Col xl={2} md={2} sm={2} className='d-none d-sm-block text-center'>
                                        <div className='vl'></div>
                                    </Col>
                                    <Col xs={12} className='d-block d-sm-none'>
                                        <div className='hl'></div>
                                    </Col>
                                    <Col xl={5} md={5} sm={5} xs={12} className='order-first order-sm-last order-md-last' >
                                        <div className='d-flex justify-content-center align-items-center'>
                                            <img src={logoChorotega} alt="Logo Cooperativa Chorotega" className='img-owner' />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body>
                        <Form>
                            <Row className='justify-content-center'>
                                <Col md="10" className='mt-3 mb-2'>
                                    <h2 className='fs-5 text-center fw-bold'>CONTRATO CON LA EMPRESA</h2>
                                </Col>
                                <div className="w-100"></div>

                                <Col md='10' sm='12' xs='12' className='mb-3'>
                                    <p className='fs-5' style={{ textAlign: 'justify' }}>
                                        Este documento es de uso exclusivo para colaboradores de la COOPERATIVA CHOROTEGA, toda información proporcionada por LA EMPRESA es de carácter confidencial y será utilizada únicamente como indicador de impacto económico de la organización.
                                    </p>

                                    <h5 className='fs-5 fw-bold pt-2 pb-2'>COMPROMISO DE LA COOPERATIVA</h5>
                                    <p className='fs-5' style={{ textAlign: 'justify' }}>
                                        La Cooperativa Chorotega se compromete a dar prioridad a los intereses de LA EMPRESA, a trabajar con profesionalismo y brindarles servicios especializados de asesoría, asistencia técnica y formación de manera que podamos contribuir a la toma de decisiones, implementación de buenas prácticas y propuestas de mejora en sus operaciones diarias.
                                    </p>

                                    <h5 className='fs-5 fw-bold pt-2 pb-2'>COMPROMISO DE LA EMPRESA</h5>
                                    <p className='fs-5' style={{ textAlign: 'justify' }}>
                                        LA EMPRESA debe participar activamente en las actividades asignadas por su asesor para completar exitosamente sus proyectos, sugerencias y propuestas de mejora, así mismo estar atento a los llamados, capacitaciones o asesoría debidamente programados.
                                    </p>

                                    <h5 className='fs-5 fw-bold pt-2 pb-2'>COMISIONES Y MEMBRESÍAS</h5>
                                    <div className='fs-5' style={{ textAlign: 'justify' }}>
                                        <ul>
                                            <li>Se retendrá honorarios equivalentes a un $0.15 por cada transacción generada por medio de la plataforma.</li>
                                            <li>El costo por cada transacción efectiva es de 2.25%.</li>
                                            <li>LA EMPRESA tendrá que facturar un mínimo de cincuenta mil lempiras mensuales (L. 50,000.00), de lo contrario se le cobrará una penalización de trescientos lempiras (L. 300.00) por no cumplir el mínimo de facturación.</li>
                                        </ul>
                                    </div>

                                    <h5 className='fs-5 fw-bold pt-2 pb-2'>BENEFICIOS</h5>
                                    <div className='fs-5' style={{ textAlign: 'justify' }}>
                                        <ul>
                                            <li>Pagos por medio de tarjeta de débito y crédito.</li>
                                            <li>Panel de movimientos donde refleja las transacciones realizadas por LA EMPRESA.</li>
                                            <li>Personalización y link de pago.</li>
                                            <li>Plan de alerta de estado de transacciones.</li>
                                            <li>Motor de reportes personalizado.</li>
                                            <li>Fotografía profesional del producto (se realizarán según planificación de giras).</li>
                                            <li>Activación de botones de pago y link de pagos para recibir pagos electrónicos por medio de tarjetas de crédito y débito.</li>
                                        </ul>
                                    </div>

                                    <h5 className='fs-5 fw-bold pt-2 pb-2'>TIEMPO DE CONTRATO</h5>
                                    <p className='fs-5' style={{ textAlign: 'justify' }}>
                                        Acuerdan las Partes a este Contrato que el mismo tendrá una duración de un (1) año y podrá darse por terminado por cualquiera de las Partes, con o sin justa causa, previo aviso por escrito en un plazo no menor de treinta (30) días calendarios. No obstante, lo anterior, COOPERATIVA CHOROTEGA podrá dar por terminado este Contrato, sin la necesidad de notificación previa en cualquiera de las siguientes ocurrencias: a) En el supuesto que LA EMPRESA contravenga cualquiera de los términos y condiciones de este contrato. b) En el supuesto que LA EMPRESA cierre o mantenga inactiva la(s) cuenta(s) bancaria(s) de Pago. c) En el supuesto que utilice los servicios de cobros electrónicos de forma ilícita o para cualquier acto no permitido por las leyes de Honduras. d) El embargo, o cualquier medida cautelar judicial, la quiebra, insolvencia o cualquier hecho o acto que afecte en cualquier forma el funcionamiento normal del (los) establecimiento(s) de LA EMPRESA.
                                    </p>
                                </Col>

                                <hr></hr>

                                <Col md='10' sm='12' xs='12' className='mb-3'>
                                    <Form.Label className='fs-5'>¿Acepta los términos del contrato?</Form.Label>
                                    <div className="d-flex">
                                        {YESNO.map((option) => (
                                            <Form.Check
                                                key={option.value}
                                                type="radio"
                                                id={`accept_terms-${option.value}`}
                                                label={option.label}
                                                value={option.value}
                                                name="accept_terms"
                                                className="me-3 fs-5"
                                                {...register("accept_terms", {
                                                    required: "Aceptar los términos es requerido",
                                                })}
                                                onClick={handleAcceptTerms}
                                                defaultChecked={formData.accept_terms === option.value}
                                            />
                                        ))}
                                    </div>
                                    {errors.accept_terms && (
                                        <p className="text-danger">
                                            {errors.accept_terms.message}
                                        </p>
                                    )}
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    )
};